import { useEnrichMetadataMutation } from '@/hooks/api/use-enrich-metadata-mutation'
import { EnrichmentType } from '../constants'
import { useEnrichmentBase } from './use-enrichment-base'

export const useTableEnrichment = (schemaName: string, originalData?: any) => {
  const tableMutation = useEnrichMetadataMutation()

  const workflow = useEnrichmentBase({
    type: 'table' as EnrichmentType,
    identifier: schemaName || '',
    mutationFn: tableMutation.mutateAsync,
    schemaName: schemaName || '',
    originalData: schemaName ? originalData : null,
  })

  return workflow
}
